/*global Klazz, Q, lunr*/
var $ = require('jquery');

(function() {
    'use strict';

    var Provider = Klazz.extend({
        /**
         * contains the results summary data that are displayed
         */
        summaryData: null,
        /**
         * the index generated by lunr
         */
        lunrIndex: null,

        //override this
        indexUrl: '',

        /**
         * load the index for the search asynchronously, promise-based
         * @returns {promise|Q.promise}
         */
        load: function() {
            var deferred = Q.defer();
            /* when starting, request the search index */
            $.ajax({
                url: this.indexUrl,
                type: 'GET',
                context: this,
                success: function(data) {
                    /* if received object seems to have the right format */
                    if ('object' === typeof data
                        && 'object' === typeof data.summary) {
                        /* even if the object has the right format, there's no way
                         of telling whether the object is all correct, so we may
                         find out this, as an error, while loading the index
                         */
                        try {
                            /* populate the summary data and the search index */
                            this.summaryData = data.summary;

                            // If an index is present, load it
                            if ('object' === typeof data.index) {
                                this.lunrIndex = lunr.Index.load(data.index);
                            } else if ('object' == typeof data.indexData) {
                                // Otherwise build the index on the fly
                                this.buildIndex(data.indexData)
                            } else {
                                deferred.reject();
                            }
                            deferred.resolve();
                        } catch(e) {
                            console && console.error && console.error(e);
                            deferred.reject();
                        }
                    } else {
                        deferred.reject();
                    }
                },
                error: function() {
                    deferred.reject();
                }
            });
            return deferred.promise;
        },

        buildIndex: function(indexData) {
            var indexerFn = this.getIndexer(indexData.locale),
                fields = indexData.fields,
                index, i, j, idxDoc, data;

            index = indexerFn(function() {
                var fieldBoosts = indexData.fieldBoosts,
                    i, fieldCfg, boost;

                //Construct each field definition, which for now contains the boost
                for (i = 0; i < fields.length; ++i) {
                    fieldCfg = {};
                    boost = fieldBoosts[fields[i]];
                    if (typeof boost !== "undefined") {
                        fieldCfg.boost = boost;
                    }

                    this.field(fields[i], fieldCfg);
                }

                // This sets the name of the UID field
                this.ref(indexData.ref);

                this.pipeline.add(lunr.removeEmpty);
            });

            // Index the data
            for (i in this.summaryData) {
                if (this.summaryData.hasOwnProperty(i)) {
                    data = this.summaryData[i];
                    idxDoc = {};
                    idxDoc[indexData.ref] = data[indexData.ref];

                    for (j = 0; j < fields.length; ++j) {
                        idxDoc[fields[j]] = data[fields[j]];
                    }

                    index.add(idxDoc);
                }
            }

            //TODO: clean summaryData of non-necessary fields

            this.lunrIndex = index;
        },

        /**
         * Returns the indexing function (flavor of lunr)
         * @param {String} locale e.g. en_US
         * @returns {Function}
         */
        getIndexer: function(locale) {
            var indexerFn;

            switch (locale) {
                case 'de_DE':
                    indexerFn = lunr.de;
                    break;

                case 'fr_FR':
                    indexerFn = lunr.fr;
                    break;

                default:
                    indexerFn = lunr;
                    break;
            }

            return indexerFn;
        },

        /**
         * search for a given string
         * @param q string
         * @returns {Array} the results list
         */
        search: function(q) {
            /* if lunrIndex was initialized */
            if (this.lunrIndex) {
                /* perform the search using the lunr library */
                var searchResults = this.lunrIndex.search(q);

                return this.buildResults(searchResults);
            }

            return [];
        },

        /**
         * Applies formatting to the results
         * By default it returns the same data that was passed when creating the index
         * It can be overriden in child classes to provide custom formatting
         * @param {Object[]} results
         * @returns {Object[]}
         */
        buildResults: function(results) {
            var resultsFinal = [],
                ref, i;

            /* add details on the results, based on the summaryData */
            for (i = 0; i < results.length; i++) {
                ref = results[i].ref;
                resultsFinal.push(this.summaryData[ref]);
            }

            return resultsFinal;
        }
    });

    module.exports = Provider;

}());



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/search/providers/Provider.js
 ** module id = 849
 ** module chunks = 0
 **/